import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-form-qiyong",
  "use": "icon-form-qiyong-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-form-qiyong\">\r\n<g>\r\n\t<path d=\"M100,200C45,200,0,155,0,100S45,0,100,0s100,45,100,100S155,200,100,200z M100,12.5c-48.1,0-87.5,39.4-87.5,87.5\r\n\t\ts39.4,87.5,87.5,87.5s87.5-39.4,87.5-87.5S148.1,12.5,100,12.5z\" />\r\n\t<path d=\"M87.5,138.8c-2.2,0-4.4-0.7-6.3-1.9c-3.7-2.5-6.2-6.2-6.2-10.6V73.8c0-4.4,2.5-8.8,6.3-10.6c3.7-2.5,8.7-1.9,12.5,0\r\n\t\tl43.7,26.2c3.7,2.5,6.3,6.3,6.3,10.6s-2.5,8.1-6.3,10.6l-43.8,26.2C91.9,138,89.7,138.7,87.5,138.8L87.5,138.8z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/form/form-qiyong.svg
// module id = HxVa
// module chunks = 13